export default "/img/v12-0-0_fig3.af7144f07ed6164ad640c409e71b3502.png";